import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/core/assets/icons/icon-drop-down.svg'
import _imports_1 from '@/core/assets/icons/icon-lock.svg'


const _withScopeId = n => (_pushScopeId("data-v-0e98013c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "input" }
const _hoisted_2 = ["id", "disabled", "multiple"]
const _hoisted_3 = ["disabled"]
const _hoisted_4 = ["value"]
const _hoisted_5 = {
  key: 1,
  value: "-"
}
const _hoisted_6 = {
  key: 0,
  src: _imports_0,
  alt: "arrow",
  class: "icon"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "lock"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_input_label = _resolveComponent("input-label")!
  const _component_tool_tip = _resolveComponent("tool-tip")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["wrapper", { error: _ctx.error }])
  }, [
    _createVNode(_component_input_label, {
      id: _ctx.id,
      disabled: _ctx.disabled,
      "has-warning": _ctx.disabled,
      "warning-message": _ctx.disabledMessage
    }, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default", {}, undefined, true)
      ]),
      _: 3
    }, 8, ["id", "disabled", "has-warning", "warning-message"]),
    _createElementVNode("section", _hoisted_1, [
      _withDirectives(_createElementVNode("select", {
        name: "select",
        id: _ctx.id,
        disabled: _ctx.disabled,
        onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.select && _ctx.select(...args))),
        multiple: _ctx.multiple,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.activeItem) = $event)),
        style: _normalizeStyle({ backgroundColor: _ctx.fill }),
        class: _normalizeClass({ empty: _ctx.value === '' })
      }, [
        (!_ctx.noPlaceholder)
          ? (_openBlock(), _createElementBlock("option", {
              key: 0,
              value: "",
              disabled: !_ctx.nullSelectable,
              selected: ""
            }, _toDisplayString(_ctx.placeholder), 9, _hoisted_3))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option, index) => {
          return (_openBlock(), _createElementBlock("option", {
            key: index,
            value: _ctx.optionKey(option)
          }, _toDisplayString(_ctx.format(option)), 9, _hoisted_4))
        }), 128)),
        (_ctx.isDisabledAndShouldBeEmpty)
          ? (_openBlock(), _createElementBlock("option", _hoisted_5, "-"))
          : _createCommentVNode("", true)
      ], 46, _hoisted_2), [
        [_vModelSelect, _ctx.activeItem]
      ]),
      (!_ctx.disabled)
        ? (_openBlock(), _createElementBlock("img", _hoisted_6))
        : _createCommentVNode("", true),
      (_ctx.disabled)
        ? (_openBlock(), _createBlock(_component_tool_tip, {
            key: 1,
            class: "icon disabled-icon",
            "horizontal-offset": 9,
            "vertical-offset": 36
          }, {
            hoverable: _withCtx(() => [
              _hoisted_7
            ]),
            "tool-tip": _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.disabledMessage), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ])
  ], 2))
}